// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"ed340840","292":"3a47acf3"}[chunkId] + ".chunk.js";
};